import { useQuery as a, useQueryClient as c, useMutation as p } from "@tanstack/react-query";
import n from "./degrees.api.js";
import { teachurKeys as u } from "../../constants/teachurKeys.js";
const q = (e, r) => a({
  queryKey: u.degrees.detail(e),
  queryFn: async () => (await n.get(e)).data,
  enabled: !!e,
  ...r
}), m = (e) => a({
  queryKey: u.degrees.list(),
  queryFn: async () => (await n.getAll()).data,
  ...e
}), Q = (e, r) => a({
  queryKey: u.degrees.courses(e),
  queryFn: async () => (await n.getCourses(e)).data,
  enabled: !!e,
  ...r
}), w = (e) => {
  const r = c(), { onSuccess: s, ...i } = e ?? {};
  return p({
    mutationFn: async ({ userId: o, toDegreeId: t }) => (await n.switchStudentDegree(o, t)).data,
    onSuccess: (o, t, y) => {
      r.invalidateQueries({
        queryKey: u.users.detail(t.userId)
      }), r.invalidateQueries({
        queryKey: u.users.userCourses(t.userId)
      }), s == null || s(o, t, y);
    },
    ...i
  });
};
export {
  Q as useGetDegreeCoursesQuery,
  q as useGetDegreeQuery,
  m as useGetDegreesQuery,
  w as useSwitchStudentDegreeMutation
};
